import { UserInfo } from "@/api/types/user"

interface MainHeaderProps {
  currentUser?: UserInfo
  organizationCode?: string
  isRefreshing?: boolean
  onRefresh: () => void
}

export default function MainHeader({
  currentUser,
  organizationCode,
  isRefreshing = false,
  onRefresh
}: MainHeaderProps) {
  return (
    <div className="bg-white border-b border-gray-200 px-4 py-2 flex items-center justify-between">
      <div className="flex items-center space-x-4">
        <h1 className="text-lg font-semibold text-gray-800">Ping</h1>
        <span className="text-sm text-gray-500">
          {organizationCode}  @ {currentUser?.nickname}
        </span>
      </div>

      <div className="flex items-center space-x-2">
        <button
          onClick={onRefresh}
          disabled={isRefreshing}
          className={`px-3 py-1 text-sm rounded-lg transition-colors flex items-center space-x-1 ${isRefreshing
              ? 'bg-gray-100 text-gray-500 cursor-not-allowed'
              : 'bg-green-100 hover:bg-green-200 text-green-700'
            }`}
          title="刷新用户信息和页面"
        >
          <svg
            className={`w-4 h-4 ${isRefreshing ? 'animate-spin' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          <span>{isRefreshing ? '刷新中...' : '刷新'}</span>
        </button>
      </div>
    </div>
  )
}
